let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gJjCK")).then(() => parcelRequire('b7BiQ'));